import { TYPE_MAP } from './hive-factory';
export default {
    uri: 26348,
    aid: 60,
    model: {
        act_id: { type: TYPE_MAP.UINT64, seq: 14596 },
        type: { type: TYPE_MAP.UINT16, seq: 14597 },
        pid: { type: TYPE_MAP.STRING, seq: 14598 },
        uid: { type: TYPE_MAP.UINT64, seq: 14599 },
        userId: { type: TYPE_MAP.STRING, seq: 14611 },
        source: { type: TYPE_MAP.STRING, seq: 14600 },
        log_type: { type: TYPE_MAP.UINT16, seq: 14601 },
        log_action: { type: TYPE_MAP.STRING, seq: 14602 },
        log_event: { type: TYPE_MAP.STRING, seq: 14603 },
        log_content: { type: TYPE_MAP.STRING, seq: 14604 },
        country_code: { type: TYPE_MAP.STRING, seq: 14605 },
        device_id: { type: TYPE_MAP.STRING, seq: 14606 },
        os: { type: TYPE_MAP.STRING, seq: 14607 },
        url: { type: TYPE_MAP.STRING, seq: 14608 },
        time: { type: TYPE_MAP.UINT64, seq: 14609 },
        extra: { type: TYPE_MAP.MAP_STRING, seq: 14610 }
    }
};
